export default Object.freeze({
  FormField: 'form-field',
  Variable: 'variable',
  InstanceName: 'instance-name',
  OperationObservations: 'operation-observations',
  OperationUserEmail: 'operation-user-email',
  OperationIsApprovalOrReject: 'operation-is-approval-or-reject',
});
